import { render, staticRenderFns } from "./TrendingSkeleton.vue?vue&type=template&id=f9c152ec"
import script from "./TrendingSkeleton.vue?vue&type=script&lang=js"
export * from "./TrendingSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports